import React from "react";
import App from "./App";

import { createRoot } from "react-dom/client";
import "./index.css";
import { AuthProvider } from "./providers/AuthProvider";
import { BrowserRouter as Router } from "react-router-dom";

import * as serviceWorker from "./serviceWorker";
import SettingsProvider from "./providers/SettingsProvider";
import { CustomersProvider } from "./providers/CustomersProvider";
import { OperativesProvider } from "./providers/OperativesProvider";
import { RatesProvider } from "./providers/RatesProvider";
import { UserProvider } from "./providers/UserProvider";
import { NotificationsProvider } from "./providers/NotificationsProvider";
import { TemplatesProvider } from "./providers/TemplatesProvider";
// require("dotenv").config();
// force push

// if (import.meta.env.MODE === "development") {
//   const { worker } = require("./__mocks__/browser");
//   worker.start();
// }

// if (module.hot) {
//   module.hot.accept();
// }

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <Router>
    <AuthProvider>
      <UserProvider>
        <SettingsProvider>
          <RatesProvider>
            <CustomersProvider>
              <OperativesProvider>
                <NotificationsProvider>
                  <TemplatesProvider>
                    <App />
                  </TemplatesProvider>
                </NotificationsProvider>
              </OperativesProvider>
            </CustomersProvider>
          </RatesProvider>
        </SettingsProvider>
      </UserProvider>
    </AuthProvider>
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
